module.exports = __webpack_public_path__ + "img/baby_7.49f8b49d.jpg";